import { saturate, tint } from "polished";

export const extensionToColor = (ext: string): string => {
  let bgColor = "";

  for (let i = 0; i < 3; i++) {
    bgColor += ext[i] ? ext.charCodeAt(i).toString(16) : "00";
  }

  return tint(0.7, saturate(1, `#${bgColor}`));
};
